cb.define([], function () {

    var PM_pmc_giftcardlist_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            var gridModel = viewmodel.getGridModel();

            gridModel.on('afterSetDataSource', () => {

                const rows = gridModel.getRows();
                //获取当前时间
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;

                rows.forEach((data, index) => {
                    if (data.status == 0) {
                        if (data.expireEndDate.split(' ')[0] < currentdate) {
                            gridModel.setCellValue(index, 'status', 3);
                        } else if (data.expireEndDate.split(' ')[0] >= currentdate && data.expireStartDate.split(' ')[0] <= currentdate) {
                            gridModel.setCellValue(index, 'status', 2);
                        } else {
                            gridModel.setCellValue(index, 'status', 1);
                        }
                    } else {
                        gridModel.setCellValue(index, 'status', 3);
                    }

                });
            });
        }
    };
    try {
        module.exports = PM_pmc_giftcardlist_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_giftcardlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_giftcardlist_VM.Extend.js